export const launchHubspotWidget = () => {
  window.HubSpotConversations && window.HubSpotConversations.widget.open();
};
